import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatHour(hour) {
  const h = Math.floor(hour);
  const m = Math.round((hour - h) * 60);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

const CURRENCY_MAP = {
  JOD: { symbol: "JD", locale: "ar-JO" },
  USD: { symbol: "$", locale: "en-US" },
};

export function formatPrice(amount, currency = "JOD") {
  const info = CURRENCY_MAP[currency] || CURRENCY_MAP.JOD;
  const num = Number(amount);
  const formatted = Number.isInteger(num) ? num.toFixed(0) : num.toFixed(2);
  return `${info.symbol}${formatted}`;
}

export const SPORT_COLORS = {
  football: { bg: "#22C55E", text: "#052E16" },
  basketball: { bg: "#FB923C", text: "#1C0F00" },
  tennis: { bg: "#FEF08A", text: "#1C1A00" },
  padel: { bg: "#38BDF8", text: "#082F49" },
  pickleball: { bg: "#A78BFA", text: "#1E1035" },
};

export function hexToRgba(hex, alpha) {
  if (!hex) return `rgba(255,255,255,${alpha})`;
  const h = hex.replace("#", "");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

export const CITIES = [
  { key: "amman", lat: 31.9454, lng: 35.9284 },
  { key: "zarqa", lat: 32.0728, lng: 36.0872 },
  { key: "irbid", lat: 32.5556, lng: 35.8497 },
  { key: "aqaba", lat: 29.5267, lng: 35.0078 },
  { key: "madaba", lat: 31.7197, lng: 35.7938 },
  { key: "salt", lat: 32.0389, lng: 35.7272 },
  { key: "karak", lat: 31.1853, lng: 35.7049 },
  { key: "mafraq", lat: 32.3429, lng: 36.2077 },
  { key: "jerash", lat: 32.2747, lng: 35.8962 },
  { key: "tafilah", lat: 30.8376, lng: 35.6051 },
  { key: "maan", lat: 30.1963, lng: 35.7341 },
  { key: "ajloun", lat: 32.3326, lng: 35.7519 },
  { key: "ramtha", lat: 32.5587, lng: 36.0067 },
];
